// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__isXny","cover_caption":"Carousel_cover_caption__CNQgx","cover_thumb":"Carousel_cover_thumb__xwagc","mobile_drag":"Carousel_mobile_drag__HW9aG"};